module.exports = __webpack_public_path__ + "static/elsaM_screen04-b1ba1a0338455b36a79e75aaa15b266a.jpg";